import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../SessionChecker/SessionChecker";
import { useTranslation } from "react-i18next";

function SuccessfulPurchase({ theme, setCheckoutStatus, setData}) {
  const [active, setActive] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    setActive(true);
    setData([]);
  }, []);

  const { currentUserUsername } = useContext(AuthContext);

  const { t } = useTranslation();

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setCheckoutStatus();
          }, 150);
        }}
      ></div>
      <div className={`popupMainDiv noPadding ${theme} ${active && "active"}`}>
        <div className="popupContentDiv">
          <div>{t("Your order has been successfully placed.")}</div>

          <div
            className="linkDiv"
            onClick={() => {
              setActive(false);
              setTimeout(() => {
                navigate("/history");
              }, 150);
            }}
          >
            {t("Check your history")}
            <img src="/icons/link.png"></img>
          </div>
        </div>
      </div>
    </>
  );
}

export default SuccessfulPurchase;
